module.exports = "https://preprod.web-phone.apps.phone.com/static/media/dtmf-1.d72dbc88.mp3";